import { render } from "./PortfolioItem.vue?vue&type=template&id=04b293f8&ts=true"
import script from "./PortfolioItem.vue?vue&type=script&lang=ts"
export * from "./PortfolioItem.vue?vue&type=script&lang=ts"

import "./PortfolioItem.vue?vue&type=style&index=0&id=04b293f8&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__